export default {
  tipoCliente: {
    TRANSPORTADOR: 1,
    EMBARCADOR: 2
  }
}


// WEBPACK FOOTER //
// ./src/helpers/tipo-cliente.js